



















































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component
export default class ShippingForm extends Vue {

  @Prop({ default: () => ({}) })
  initialData!: any

  @Prop({ default: () => 'payment' })
  mode!: 'payment' | 'confirm'

  data = {} as any

  @Prop({ default: false })
  thirdParty!: boolean

  completed = false

  mounted() {
    this.data = { ...this.initialData }
  }

  required(v: any): string | true {
    return !!v || 'Field is required'
  }

  submit() {
    const form = (this.$refs.form) as any
    
    if (form.validate()) {
      this.$emit('submit', this.data)
      this.completed = true
    }
  }
}
